/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var _get = require('lodash.get');
var moment = require('moment');

var cleanUpResponse = require('common/util/cleanUpResponse');
var text = require('common/util/xmlText');

module.exports = function() {
  var deferred = $.Deferred();

  $.soap({
    body: {
      GetAssignedTasks: {
        $xmlns: 'http://dobs.pa.gov/dp/task/bpm/1.0'
      }
    },
    blueprintArrays: [
      'GetAssignedTasksResponse.Tasks.NOTF_TASK_INSTANCE',
      'GetAssignedTasksResponse.TaskTypes.CM_LU_TaskType',
      'GetAssignedTasksResponse.Filings.DP_Filing',
      'GetAssignedTasksResponse.Exams.DP_EntityExam',
      'GetAssignedTasksResponse.Correspondences.DP_Correspondence'
    ],
    blueprint: {
      tasks: [
        '$..NOTF_TASK_INSTANCE',
        {
          taskId: '$..TaskId',
          deliveryDate: '$..DeliveryDate',
          claimedDate: '$..ClaimedDate',
          entityId: '$..DPEntityID',
          examId: '$..DPExamID',
          taskTypeName: '$..TaskTypeName',
          filingId: '$..DPFilingID',
          correspondenceId: '$..DPCorrespondenceID'
        }
      ],
      taskMetaData: {
        taskTypes: [
          '$..CM_LU_TaskType',
          {
            id: '$.ID',
            name: '$.Name',
            description: '$.Description'
          }
        ],
        filings: [
          '$..DP_Filing',
          {
            id: '$..FilingID',
            entityName: '$..EntityName',
            filingType: '$..FilingType',
            decisionDueDate: '$..DecisionDueDate',
            submissionTypeName: '$..SubmissionTypeName',
            filingTypeId: '$..FilingTypeID'
          }
        ],
        exams: [
          '$..DP_EntityExam',
          {
            id: '$..ID',
            entityName: '$..EntityName',
            examType: '$..ExamType',
            dueDate: '$..DueDate'
          }
        ],
        correspondences: [
          '$..DP_Correspondence',
          {
            correspondenceID: '$..CorrespondenceID',
            entityName: '$..EntityName'
          }
        ]
      }
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      _.each(response.tasks, function(task) {
        task.deliveryDate = moment.utc(task.deliveryDate, moment.ISO_8601).local();
        task.claimedDate = task.claimedDate ? moment(task.claimedDate, moment.ISO_8601) : undefined;

        // The Assigned/Claimed date represents when a task started belonging
        // to a specific user.
        task.assignedClaimedDate = task.deliveryDate;
        if (task.claimedDate && task.claimedDate.isValid()) {
          task.assignedClaimedDate = task.claimedDate;
        }
        var entityId = text(_get(task, 'entityId', {}));
        var taskTypeName = text(_get(task, 'taskTypeName', {}));
        var filingId = text(_get(task, 'filingId', {}));
        var examId = text(_get(task, 'examId', {}));
        var correspondenceId = text(_get(task, 'correspondenceId', {}));

        var type = _.find(response.taskMetaData.taskTypes, function(type) {
          return taskTypeName === type.name;
        });
        task.type = type.description;

        if (filingId) {
          var filing = _.find(response.taskMetaData.filings, function(filing) {
            return filingId === filing.id;
          });

          if (filing) {
            //add submission type to filing type if generic submission
            if (_.includes(['100', '200', '300'], filing.filingTypeId) && filing.submissionTypeName) {
              task.filingType = filing.filingType + ' - ' + filing.submissionTypeName;
            } else {
              task.filingType = filing.filingType;
            }
            task.entityName = filing.entityName;
            if (filing.decisionDueDate) {
              task.dueDate = moment(filing.decisionDueDate, 'YYYY-MM-DD');
            }
            // Update task name for submissions
            if (_.includes(['111', '205', '305', '306', '307'], filing.filingTypeId)) {
              task.type = 'Review Submission';
            }
          }
        }

        if (examId) {
          var exam = _.find(response.taskMetaData.exams, function(exam) {
            return examId === exam.id;
          });
          if (exam) {
            task.entityName = exam.entityName;
            if (exam.dueDate) {
              task.dueDate = moment(exam.dueDate, 'YYYY-MM-DD');
            }
            task.filingType = '--';
          }
        }

        if (correspondenceId) {
          var correspondence = _.find(response.taskMetaData.correspondences, function(correspondence) {
            return correspondenceId === correspondence.correspondenceID;
          });
          if (correspondence) {
            task.entityName = correspondence.entityName;
          }
        }
      });

      deferred.resolve(response.tasks);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
